// 8.3.7 — learner level control (merged into the locale as `lvl`).
const lvl = {
  "changeLevel": "Changer de niveau",
  "title": "Change ton niveau en {lang}",
  "help": "Choisis le niveau qui te correspond. Tu peux le changer à tout moment.",
  "safe": "Tes mots enregistrés, tes révisions et ta progression sont conservés.",
  "save": "Enregistrer le niveau",
  "cancel": "Annuler",
  "saving": "Enregistrement…",
  "changed": "Niveau changé : {level}. Tes prochains exercices s'adapteront à ton nouveau niveau.",
  "failed": "Impossible de changer ton niveau. Réessaie.",
  "current": "Actuel",
  "profilesHelp": "Ton profil de langue et son niveau CECRL. Changer de niveau n'affecte que tes prochains exercices.",
  "levels": {
    "A1": {
      "name": "Débutant",
      "desc": "Des mots de base et des phrases simples du quotidien."
    },
    "A2": {
      "name": "Élémentaire",
      "desc": "Des situations familières et de courtes conversations."
    },
    "B1": {
      "name": "Intermédiaire",
      "desc": "Tu te débrouilles dans les conversations du quotidien, de plus en plus en autonomie."
    },
    "B2": {
      "name": "Intermédiaire avancé",
      "desc": "Tu parles de nombreux sujets avec naturel et comprends une langue plus complexe."
    },
    "C1": {
      "name": "Avancé",
      "desc": "Tu t'exprimes avec aisance et maîtrises les nuances de la langue."
    },
    "C2": {
      "name": "Maîtrise",
      "desc": "Tu comprends et exprimes presque tout avec précision."
    }
  }
};
export default lvl;
